import { parseString, processors } from "xml2js";
import axios from "axios";

export const getXML = async (url) => {
    const data = await axios
        .get(url, {
            "Content-Type": "application/xml; charset=utf-8",
        })
        .then((res) => {
            return res.data;
        });
    let configData;
    parseString(
        data,
        {
            mergeAttrs: true,
            explicitArray: false,
            attrValueProcessors: [processors.parseNumbers, processors.parseBooleans],
        },
        (err, result) => {
            if (err) {
                console.error(err);
            } else {
                configData = result;
            }
        }
    );
    return configData;
};
